import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import "./GlobalConfig.css";
import setupLocatorUI from "@locator/runtime";
import {BackTop} from "antd";
import {Provider} from "react-redux";
import store from "./Redux/Store";
import {ReactComponent as UpArrow} from "./assets/icons/scrollToTop.svg";

if (process.env.NODE_ENV === "development") {
  setupLocatorUI();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
    <BackTop visibilityHeight={700}>
      <div className="ant-back-top-inner ">
        <UpArrow />
      </div>
    </BackTop>
  </Provider>,
);
